import React, { useState } from "react";
import { Pie, Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartColumn, faChartPie, faEye } from '@fortawesome/free-solid-svg-icons';

import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { useNavigate } from "react-router-dom";

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function Charts({ chartData, detailView }) {
  const bgColorArr = [
    "#45aaf2", "#20bf6b", "#FFCE56", "#4BC0C0", "#9966FF", "#2d3436",
    "#FF9F40", "#1abc9c", "#e74c3c", "#9b59b6", "#f1c40f", "#34495e",
  ];

  const [chartType, setChartType] = useState("pie");
  const navigate = useNavigate();

  const toggleChartType = () => {
    setChartType((prevType) => (prevType === "pie" ? "table" : "pie"));
  };

  const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // We'll render legend manually
      },
      title: {
        display: false,
      },
    },
  };

  return (
    <div className="mt-10 relative">
      {/* Toggle Button */}
      <div className="absolute right-4 top-0 group">
        <button
          onClick={toggleChartType}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-700 hover:scale-110 text-white text-sm transition"
        >
          {chartType === "pie" ? <FontAwesomeIcon icon={faChartColumn} /> : <FontAwesomeIcon icon={faChartPie} />}
        </button>
        <div className="absolute text-nowrap top-full mt-1 right-16 translate-x-1/2 bg-gray-700 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Switch to {chartType === "pie" ? "table" : "Pie Chart"} 
        </div>
      </div>

      {/* Chart Grid */}
      <div className="flex flex-wrap gap-8 justify-center mt-8">
        {chartData?.map((item, index) => {
          const keys = Object.keys(item).filter((key) => key !== "label");
          const values = keys.map((key) => item[key]);

          const data = {
            labels: keys,
            datasets: [
              {
                label: `${item.label} Stats`,
                data: values,
                backgroundColor: bgColorArr,
                borderColor: "#fff",
                borderWidth: 1,
              },
            ],
          };

          return (
            <div key={index} className="w-[250px] flex flex-col items-center">
              <h2 className="text-xl font-semibold mb-4 text-center">{item.label}</h2>
              <div className="w-[250px]">
              {chartType === "pie" ? (
  <Pie data={data} options={commonOptions} />
) : (
  <div className="w-full overflow-auto">
    <table className="min-w-[250px] text-xs border border-gray-300">
      <thead className="bg-gray-100">
        <tr>
          <th className="border border-gray-300 px-2 py-1">Label</th>
          <th className="border border-gray-300 px-2 py-1">Value</th>
        </tr>
      </thead>
      <tbody>
        {keys.map((key, i) => (
          <tr key={i} className="text-center">
            <td className="border border-gray-300 px-2 py-1">{key}</td>
            <td className="border border-gray-300 px-2 py-1">{item[key]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

              </div>

              {/* Custom Legend */}
              {chartType=="pie" &&  <div className="mt-4 space-y-1 text-xs max-h-[120px] overflow-y-auto text-center">
                {data.labels.map((label, i) => (
                  <div key={i} className="flex items-center justify-center gap-2 px-2">
                    <span className="w-3 h-3 inline-block rounded-sm" style={{ backgroundColor: bgColorArr[i % bgColorArr.length] }}></span>
                    <span>{label}</span>
                  </div>
                ))}
              </div>}
             

              {detailView && (
                <div
                  className="text-center mt-2 cursor-pointer"
                  onClick={() => navigate(`/${item.label}`)}
                >
                  Detail View <FontAwesomeIcon className="ml-1" icon={faEye} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
